import React, { createContext, useContext, useState } from 'react';

const TelemedicinaContext = createContext();

export const TelemedicinaProvider = ({ children }) => {
  const [paciente, setPaciente] = useState(null);
  const [medicoSelecionado, setMedicoSelecionado] = useState(null);

  const [agendamento, setAgendamento] = useState({
    especialidadeId: null,
    medicoId: null,
    agendaexamesId: null,
    horario: '',
    data: '',
    paciente: null,
    atendimento_gratuito: false,
    plano_id: null,
    faltou: false,
    pronto_atendimento_gratis: false, 
    telemedicina_especialista_gratis: false,
    especialista: false
  });

  const atualizarAgendamento = (dados) => {
    setAgendamento((prev) => ({ ...prev, ...dados }));
  };

  return (
    <TelemedicinaContext.Provider value={{ paciente, setPaciente, agendamento, setAgendamento, atualizarAgendamento, medicoSelecionado, setMedicoSelecionado }}>
      {children}
    </TelemedicinaContext.Provider>
  );
};

export const useTelemedicina = () => useContext(TelemedicinaContext);
